// import multiimage1 from '../jpeg/view/zc.jpg';
// import multiimage2 from '../jpeg/view/t.jpg';
// import multiimage3 from '../jpeg/view/zs.jpg';

import ao1 from '../jpeg/service-banner/analytics-optimization/1.jpg';
import ao2 from '../jpeg/service-banner/analytics-optimization/2.jpg';
import ao3 from '../jpeg/service-banner/analytics-optimization/3.jpg';
import ao4 from '../jpeg/service-banner/analytics-optimization/4.jpg';
import ao5 from '../jpeg/service-banner/analytics-optimization/5.jpg';

import mr1 from '../jpeg/service-banner/market-research/1.jpg';
import mr2 from '../jpeg/service-banner/market-research/2.jpg';
import mr3 from '../jpeg/service-banner/market-research/3.jpg';
import mr4 from '../jpeg/service-banner/market-research/4.jpg';
import mr5 from '../jpeg/service-banner/market-research/5.jpg';

import sd1 from '../jpeg/service-banner/store-dev/1.jpg';
import sd2 from '../jpeg/service-banner/store-dev/2.jpg';

import so1 from '../jpeg/service-banner/setup-optimization/1.jpg';
import so2 from '../jpeg/service-banner/setup-optimization/2.jpg';
import so3 from '../jpeg/service-banner/setup-optimization/3.jpg';
import so4 from '../jpeg/service-banner/setup-optimization/4.jpg';
import so5 from '../jpeg/service-banner/setup-optimization/5.jpg';

import b1 from '../jpeg/service-banner/branding/1.jpg';
import b2 from '../jpeg/service-banner/branding/2.jpg';
import b3 from '../jpeg/service-banner/branding/3.jpg';
import b4 from '../jpeg/service-banner/branding/4.jpg';

import m1 from '../jpeg/service-banner/marketing/1.jpg';
import m2 from '../jpeg/service-banner/marketing/2.jpg';
import m3 from '../jpeg/service-banner/marketing/3.jpg';
import m4 from '../jpeg/service-banner/marketing/4.jpg';
import m5 from '../jpeg/service-banner/marketing/5.jpg';

const analyticsOptimization = [{
    img: ao1
},
{
    img: ao2
},
{
    img: ao3
},
{
    img: ao4
},
{
    img: ao5
},
]

const marketResearch = [{
    img: mr1
},
{
    img: mr2
},
{
    img: mr3
},
{
    img: mr4
},
{
    img: mr5
},
]

const storeDev = [{
    img: sd1
},
{
    img: sd2
},
]

const setupOptimization = [{
    img: so1
},
{
    img: so2
},
{
    img: so3
},
{
    img: so4
},
{
    img: so5
}]

const branding = [{
    img: b1
},
{
    img: b2
},
{
    img: b3
},
{
    img: b4
},
]

const marketing = [{
    img: m1
},
{
    img: m2
},
{
    img: m3
},
{
    img: m4
},
{
    img: m5
},
]

export const sectionEcommerce = [
    //name: All
    // {
    //     name: 'All',
    //     services: [
    //         ...analyticsOptimization
    //         , ...marketResearch
    //         , ...storeDev
    //     ]
    // }, 
    {
        name: 'Setup and Optimization',
        services: setupOptimization
    },
    {
        name: 'Analytics and Optimization',
        services: analyticsOptimization
    },
    {
        name: 'Market Research',
        services: marketResearch
    },
    
    {
        name: 'Store Development',
        services: storeDev
    },
   {
        name: 'Marketing',
        services: marketing
    },
    {
        name: 'Branding',
        services: branding
    },
    
    // {
    //     name: 'Store Setup/Optimization',
    //     services: multiDisplay
    // },
    // {
    //     name: 'Ecommerce Marketing',
    //     services: multiDisplay3
    // },
    // {
    //     name: 'Store Management',
    //     services: multiDisplay2
    // }
];
